import useAuth from '../useAuth';

const DashboardView = () => {
    const { claim } = useAuth();

    console.log(claim);

    return (
        <div className="view">
            <h1 className="heading">Welcome to the dashboard { claim.name }</h1>
        </div>
    )
};

export default DashboardView;
